import { useEffect } from "react";
import ReactDOMServer from "react-dom/server";
import Shepherd from "shepherd.js";
import "shepherd.js/dist/css/shepherd.css";
import "./style.scss";

const Tour = ({ tourId, steps, tutComplete, handleTourComplete }) => {
  useEffect(() => {
    // if Tutorial is completed return null
    if (tutComplete) {
      return null; // Skip Shepherd Tour if not the first visit
    }

    const tour = new Shepherd.Tour({
      defaultStepOptions: {
        classes: "shepherd-tour",
        scrollTo: { behavior: "smooth", block: "center" },
      },
      useModalOverlay: true,
      disableScrolling: true,
      disableOverlayClose: true,
      disableCloseOnEsc: true,
      spotlightClicks: true,
      showProgress: true,
      showSkipButton: true,
    });

    steps.forEach((step, index) => {
      const buttons = [];

      // Add Skip button as the first button (left side) for all steps except the last
      if (index < steps.length - 1) {
        buttons.push({
          text: "Skip tour",
          action: () => {
            tour.cancel();
            handleTourComplete(tourId, true);
          },
          classes: "shepherd-button-skip",
        });
      }

      if (index === 0) {
        buttons.push({
          text: "Next",
          action: tour.next,
          classes: "shepherd-button-primary",
        });
      } else if (index === steps.length - 1) {
        buttons.push({
          text: "Previous",
          action: tour.back,
          classes: "shepherd-button-secondary",
        });
        buttons.push({
          text: step?.locale?.last || "Done",
          action: () => {
            tour.complete();
            handleTourComplete(tourId, true);
          },
          classes: "shepherd-button-primary",
        });
      } else {
        buttons.push({
          text: "Previous",
          action: tour.back,
          classes: "shepherd-button-secondary",
        });
        buttons.push({
          text: "Next",
          action: tour.next,
          classes: "shepherd-button-primary",
        });
      }

      tour.addStep({
        ...step,
        text: ReactDOMServer.renderToString(step.text),
        buttons,
      });
    });

    // Add event handlers for step transitions
    tour.on("show", (event) => {
      const element = event.step.getElement();
      if (element) {
        element.classList.add("shepherd-animate-in");
      }
    });

    tour.on("hide", (event) => {
      const element = event.step.getElement();
      if (element) {
        element.classList.remove("shepherd-animate-in");
      }
    });

    tour.start();

    return () => {
      tour.complete();
    };
  }, [steps, tourId, handleTourComplete, tutComplete]);

  return null;
};

export default Tour;
